import { getGFT } from '@/common/utils/ajax'
export default {
    data () {
        return {
            consultant_medals: [],
            show_consultant_medal: false
        }
    },
    methods: {
        async showConsultantMedal (consultant_id) {
            if (!this.consultant_medals.length) {
                const { items } = await getGFT('v1/consultant_medals', {
                    consultant_id
                })
                this.consultant_medals = items
            }
            this.show_consultant_medal = true
        }
    }
}
